import { create } from "zustand";
import { persist } from "zustand/middleware";

const useProductLayoutStore = create(
    persist(
        (set, get) => ({
            layout: "grid",
            setLayout: (mode) => {
                set({ layout: mode });
            },
        }),
        {
            name: "layout-store", // LocalStorage key
        }
    )
);

export default useProductLayoutStore;
